import { useQuery } from '@tanstack/react-query';
import API from 'api/api.config';

/**
 * TODO: We may need to add a backend fix that only retrieves jobs for a specific
 * meta-analysis ID. For a user that runs many, many jobs, the JSON will grow quite large.
 *
 * ...though maybe this wont be an issue if the data is purged after a certain amount of time.
 */

const useGetMetaAnalysisJobsByMetaAnalysisId = (metaAnalysisId: string | undefined, enabled: boolean = true) => {
    return useQuery({
        queryKey: ['meta-analysis-jobs', metaAnalysisId],

        queryFn: async () => {
            const res = await API.NeurosynthServices.MetaAnalysisService.metaAnalysisJobsGet();
            return res.data.results
                ?.filter((job) => job.meta_analysis_id === metaAnalysisId)
                .sort((a, b) => new Date(a.created_at ?? '').getTime() - new Date(b.created_at ?? '').getTime());
        },

        enabled: enabled && !!metaAnalysisId
    });
};

export default useGetMetaAnalysisJobsByMetaAnalysisId;
